import * as React from "react";
import AppAuthenticated from "./AppAuthenticated";
import AppUnauthenticated from "./AppUnauthenticated";
import {
  AppFullFallbackComponent,
  LibFullPageDNASpinner,
} from "./components/lib";
import { useAuth } from "./providers/AuthProvider";

const App = () => {
  const { user, isLoadingProfile, isErrorProfile } = useAuth();

  // Has user but cant load profile, means error
  if (user && isErrorProfile) {
    return <AppFullFallbackComponent />;
  } else if (user && user.username) {
    // We have a user and loading profile
    if (isLoadingProfile) {
      return <LibFullPageDNASpinner />;
    } else {
      // Have a user and profile is loaded
      return (
        <div>
          <React.Suspense fallback={<LibFullPageDNASpinner />}>
            <AppAuthenticated></AppAuthenticated>
          </React.Suspense>
        </div>
      );
    }
  }

  // No user
  return (
    <div>
      <React.Suspense fallback={<LibFullPageDNASpinner />}>
        <AppUnauthenticated></AppUnauthenticated>
      </React.Suspense>
    </div>
  );
};

export default App;
